module.exports = __webpack_public_path__ + "media/images/logo_baloise-bbecd361.png";